import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=919ae85a&scoped=true"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"
import style0 from "./Denied.vue?vue&type=style&index=0&id=919ae85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919ae85a",
  null
  
)

/* custom blocks */
import block0 from "./Denied.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports